import { toast } from "react-toastify";
import DeleteModal from "../DeleteModal";
import QnAModal from "../QnAModal";
import { useState, useEffect } from "react";
import { Tooltip, OverlayTrigger, Dropdown, Modal, Row, Col } from "../../../evo/bootstrap";
import { deleteQnA, get_All_qna, getConfigByID, getQuestion, InsertMandetoryQue, PublishConfig } from "../../Services/chatbot";
import { sanitizeHtml } from "../../Helper/sanitize";
import { MessageCircleQuestion, Pencil, Plus, Search, Trash2 } from "lucide-react";
import { htmlToText } from "@/components/admin/text";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { InputGroup, InputGroupAddon, InputGroupInput } from "@/components/ui/input-group";
import { EmptyState, SectionCard } from "@/components/admin/cards";




const Link = ({ id, children, title }: any) => (
    <OverlayTrigger overlay={<Tooltip id={id || 'tooltip'}>{title}</Tooltip>}>
        {children}
    </OverlayTrigger>
);


const Faq = ({ setPublishTrigger, setPublishModal, setIsNeedPublish, shouldLoadQna, onLoaded, setIsDirty, isDirty }: any) => {
    const [mandatoryQuestions, setMandatoryQuestions] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [visibleCount, setVisibleCount] = useState(10);
    const [deleteDisplayLabel, setDeleteDisplayLabel] = useState('');
    const [openAccordionId, setOpenAccordionId] = useState<any>(null);
    const [confirmModal, setConfirmModal] = useState<any>({
        show: false,
        id: null,
        label: '',
        onConfirm: null,
    });

    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState<any>("")
    const [editingQuestionId, setEditingQuestionId] = useState<any>(null);
    const [serachTerm, setSearchTerm] = useState("")
    const [constData, setConstData] = useState<any>([])
    const [newQuestionDraft, setNewQuestionDraft] = useState<any>({ question: '', answer: '', intentID: '', order_id: '', propertyID: '', type: '' });
    const [data, setData] = useState<any>([])
   

    useEffect(() => {
        if (shouldLoadQna) {
            getAllFaqData();
            onLoaded();  // ✅ reset the trigger after loading
        }
    }, [shouldLoadQna]);

    const getAllFaqData = async () => {
        setLoading(true);
        try {
            const res = await get_All_qna();
            if (res?.status === 200 && res?.data) {
                const sanitized = res.data.map(item => ({
                    ...item,
                    answer: sanitizeHtml(item.answer),
                }));
                setData(sanitized);
            } else {
                setData([]);
            }
        } catch (error) {
            setData([]);

            // Safely check error response (especially when using Axios)
            if (error?.response?.status === 401) {
                toast.error("Access denied. Please verify using a valid link.");
            } else {
                console.error("Failed to load FAQ data:", error);
                // toast.error("Failed to load data. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (data && Array.isArray(data)) {
            const withIds = data.map((q, index) => ({
                ...q,
                id: Date.now() + index,
                isNew: false
            }));

            // Sort by order_id DESC
            const sorted = withIds.sort((a, b) => Number(b.order_id) - Number(a.order_id));

            setMandatoryQuestions(sorted);
            setConstData(sorted)
        } else {
            setMandatoryQuestions([]);
            setConstData([]);
        }
    }, [data]);

    const toggleShowMore = () => {
        setVisibleCount(mandatoryQuestions.length);
    };


    const toggleShowLess = () => {
        setVisibleCount(10);
    };



    const handleOpenAddModal = (e) => {
        e.preventDefault();
        const newId = Date.now();
        setEditingQuestionId(newId);
        setNewQuestionDraft({ question: '', answer: '' });
        setShowAddModal(true);
    };
    const handleOpenEditModal = async (e, q) => {
        e.preventDefault();
        setLoading(true)
        let res;
        const inputData = {
            // propertyID: propertyId,
            intentID: q.intentID
        }
        try {
            res = await getQuestion(inputData);
            const quedata = res.data;
            if (res.status === 200) {
                if (quedata.answer) {
                    quedata.answer = sanitizeHtml(quedata.answer);
                }
                setNewQuestionDraft(quedata);
                setLoading(false)
            }
            else {
                toast.error("error fetching data")
            }
        } catch (error) {
            if (error.status === 401) {
                toast.error("Access denied. Please verify using a valid link.")
            }
            console.error("Failed to load config:", error);
            toast.error(error.message || "Something went wrong")
        } finally {
            setLoading(false)
        }

        setShowEditModal(true);
    };




    const handleDeleteConfirmed = async (q, deleteId) => {
        setLoading(true)
        let res;
        const inputData = {
            // propertyID: propertyId,
            intentID: q.intentID
        }
        try {
            res = await deleteQnA(inputData);

            if (res.status === 200) {

                toast.success(res.data.message);
                const updated = mandatoryQuestions.filter(q => q.id !== deleteId);
                setMandatoryQuestions(updated);
                setIsDirty(false)
                setLoading(false)
                setIsNeedPublish(true)
                setPublishTrigger(prev => prev + 1);
            }
            else {
                toast.error(res.data.message)
            }
        } catch (error) {
            if (error.status === 401) {
                toast.error("Access denied. Please verify using a valid link.")
            }
            console.error("Failed to load config:", error);
            toast.error(error.message || "Something went wrong")
        } finally {
            setLoading(false)
        }



        setDeleteId(null);
    };


    // const handlePublish = async (e) => {
    //     e.preventDefault();
    //     setPublishError("");
    //     setPublishing(true)
    //     try {

    //         const res = await getConfigByID({ propertyID: propertyId });

    //         if (res.status === 200 && res.data) {

    //             const publishRes = await PublishConfig({ propertyID: propertyId });
    //             if (publishRes.status === 200) {
    //                 toast.success(publishRes.data?.message || "Configuration published!");
    //             } else {
    //                 toast.error(publishRes.data?.message || "Failed to publish.");
    //             }
    //         } else {

    //             setPublishError("Please fill data before publishing.");
    //         }
    //     } catch (error) {
    //         if (error?.response?.status === 404) {

    //             setPublishError("Please fill data before publishing.");
    //         } else {
    //             toast.error("Something went wrong.");
    //             console.error("Publish error:", error);
    //         }
    //     } finally {
    //         setPublishing(false)
    //     }
    // };

    const handleSearch = (e) => {
        const searchValue = e.target.value;

        if (searchValue !== "") {

            const filteredData = constData.filter((data) =>
                data.question?.toLowerCase().includes(searchValue.toLowerCase())
            );

            setMandatoryQuestions(filteredData);
        } else {
            setMandatoryQuestions(constData)
        }
    };

    const saveQuetion = async (e) => {
        e.preventDefault();
        setModalLoading(true);

        const trimmedQuestion = newQuestionDraft.question.trim();
        const trimmedAnswer = newQuestionDraft.answer.trim();

        const newError: Record<string, any> = {};
        if (!trimmedQuestion) newError.question = "Question is required";
        if (!trimmedAnswer) newError.answer = "Answer is required";

        if (Object.keys(newError).length > 0) {
            setErrorMsg(newError);
            setModalLoading(false);
            return;
        }

        const currentMax = mandatoryQuestions.reduce((max, q) => {
            const num = parseInt(q.order_id);
            return num > max ? num : max;
        }, 0);

        const newOrder = currentMax + 1;
        const newItem = {
            id: editingQuestionId,
            type: "QnA",
            intentID: `Q${newOrder}`,
            question: trimmedQuestion,
            answer: sanitizeHtml(trimmedAnswer),
            order_id: newOrder.toString()
        };

        try {
            const res = await InsertMandetoryQue(newItem);
            if (res.status === 200) {
                toast.success(res.data.message);
                setMandatoryQuestions([newItem, ...mandatoryQuestions]);
                setIsNeedPublish(true)
                setPublishTrigger(prev => prev + 1);
            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            if (error.status === 401) {
                toast.error("Access denied. Please verify using a valid link.");
            }
            console.error("Failed to load config:", error);
            toast.error(error.message || "Something went wrong");
        } finally {
            setModalLoading(false);
            setErrorMsg({});
            setShowAddModal(false); // close modal first
            setEditingQuestionId(null);
            setNewQuestionDraft({ question: '', answer: '', intentID: '', order_id: '', propertyID: '', type: '' });

            // ✅ Reset dirty state only AFTER modal close
            setTimeout(() => {
                setIsDirty(false);
            }, 0);
        }
    };


    const updateQuetion = async (e) => {
        e.preventDefault();
        setModalLoading(true);

        const trimmedQuestion = newQuestionDraft.question.trim();
        const trimmedAnswer = newQuestionDraft.answer.trim();

        const newError: Record<string, any> = {};
        if (!trimmedQuestion) newError.question = "Question is required";
        if (!trimmedAnswer) newError.answer = "Answer is required";

        if (Object.keys(newError).length > 0) {
            setErrorMsg(newError);
            setModalLoading(false);
            return;
        }

        const { propertyID, ...safeData } = { ...newQuestionDraft, answer: sanitizeHtml(trimmedAnswer) };

        try {
            const res = await InsertMandetoryQue(safeData);
            if (res.status === 200) {
                toast.success(res.data.message);
                setMandatoryQuestions(prev =>
                    prev.map(q =>
                        q.intentID === newQuestionDraft.intentID ? { ...q, ...newQuestionDraft } : q
                    )
                );
                setIsNeedPublish(true)
                setPublishTrigger(prev => prev + 1);
            } else {
                toast.error("Failed to update.");
            }
        } catch (error) {
            if (error.status === 401) {
                toast.error("Access denied. Please verify using a valid link.");
            }
            console.error("Failed to load config:", error);
            toast.error(error.message || "Something went wrong");
        } finally {
            setModalLoading(false);
            setShowEditModal(false); // close modal first
            setEditingQuestionId(null);
            setNewQuestionDraft({ question: '', answer: '', intentID: '', order_id: '', propertyID: '', type: '' });

            // ✅ Reset dirty state only AFTER modal close
            setTimeout(() => {
                setIsDirty(false);
            }, 0);
        }
    };


    const visibleQuestions = mandatoryQuestions.slice(0, visibleCount);

    return (
        <>
            <div className="position-relative">
                {loading && (
                    <div className="loaderOverlay zIndex-1023"><div className="loading"><div className="main-loader"></div></div></div>
                )}

                <section data-evo-island aria-labelledby="faqHeading"
                    className={cn("text-foreground", loading && "pointer-events-none blur-sm")}>
                    <SectionCard
                        icon={<MessageCircleQuestion />}
                        title={<>Your FAQs <Badge variant="secondary" aria-label={`${mandatoryQuestions.length} FAQs`}>{mandatoryQuestions.length}</Badge></>}
                        description="Click a question or the pencil to edit it. The chatbot uses these answers word for word."
                        actions={
                            <Button type="button" onClick={handleOpenAddModal}>
                                <Plus aria-hidden="true" />Add FAQ
                            </Button>
                        }
                    >
                        <InputGroup className="sm:max-w-sm">
                            <InputGroupAddon><Search aria-hidden="true" /></InputGroupAddon>
                            <InputGroupInput
                                type="search"
                                aria-label="Search FAQ"
                                placeholder="Search FAQ..."
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    handleSearch(e);
                                }}
                            />
                        </InputGroup>

                        {visibleQuestions.length === 0 && !loading && (
                            serachTerm.trim() ? (
                                <EmptyState icon={<Search />} title="No matching FAQs"
                                    description={`No question contains "${serachTerm.trim()}". Try another word.`} />
                            ) : (
                                <EmptyState icon={<MessageCircleQuestion />} title="No FAQs yet"
                                    description="Click Add FAQ to add the first question your guests ask." />
                            )
                        )}

                        {visibleQuestions.length > 0 && (
                            <ul className="question-div grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3" aria-label="FAQs">
                                {visibleQuestions.map((q) => (
                                    <li key={q.id} data-testid="faq-row"
                                        className="group flex min-w-0 cursor-pointer flex-col gap-2 rounded-xl border border-border bg-card p-4 text-card-foreground shadow-xs transition-all hover:border-primary/40 hover:shadow-md focus-within:border-primary/60"
                                        onClick={(e) => handleOpenEditModal(e, q)}>
                                        <div className="flex items-start justify-between gap-2">
                                            <button type="button" className="min-w-0 flex-1 pt-1 text-left text-sm font-semibold leading-5 break-words focus-visible:underline focus-visible:outline-none">{q.question}</button>
                                            <div className="flex items-center gap-0.5">
                                                <Button type="button" variant="ghost" size="icon" title="Edit"
                                                    className="edit-btn size-8 text-muted-foreground hover:text-foreground"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleOpenEditModal(e, q)
                                                    }}>
                                                    <Pencil aria-hidden="true" /><span className="sr-only">Edit</span>
                                                </Button>
                                                <Button type="button" variant="ghost" size="icon" title="Remove"
                                                    className="size-8 text-destructive hover:bg-destructive/10 hover:text-destructive"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setConfirmModal({
                                                            show: true,
                                                            label: `${q.question}`,
                                                            onConfirm: () => handleDeleteConfirmed(q, q.id),
                                                        });
                                                    }}>
                                                    <Trash2 aria-hidden="true" /><span className="sr-only">Remove</span>
                                                </Button>
                                            </div>
                                        </div>
                                        <p className="line-clamp-2 min-h-10 text-sm text-muted-foreground break-words">{htmlToText(q.answer) || "No answer yet"}</p>
                                    </li>
                                ))}
                            </ul>
                        )}

                        {mandatoryQuestions.length > 10 && (
                            <div className="flex justify-center">
                                {visibleCount < mandatoryQuestions.length ? (
                                    <Button type="button" variant="outline" size="sm" onClick={toggleShowMore}>
                                        Show More
                                    </Button>
                                ) : (
                                    <Button type="button" variant="outline" size="sm" onClick={toggleShowLess}>
                                        Show Less
                                    </Button>
                                )}
                            </div>
                        )}
                    </SectionCard>
                </section>
            </div>
            <DeleteModal
                show={confirmModal.show}
                label={confirmModal.label}
                onClose={() => setConfirmModal({ ...confirmModal, show: false })}
                onConfirm={confirmModal.onConfirm}
            />


            {/* Add modal */}
            <QnAModal
                setIsDirty={setIsDirty}
                show={showAddModal || showEditModal}
                onHide={() => {
                    setErrorMsg("")
                    setShowAddModal(false);
                    setShowEditModal(false);
                    setIsDirty(false);
                }}
                mode={showEditModal ? "edit" : "add"}
                loading={modalLoading}
                draft={newQuestionDraft}
                setDraft={setNewQuestionDraft}
                onSubmit={showEditModal ? updateQuetion : saveQuetion}
                errorMsg={errorMsg}
                setErrorMsg={setErrorMsg}
                isDirty={isDirty}
                setPublishModal={setPublishModal}
            />


          


        </>
    )
}

export default Faq;
